const getBrowser = () => {
  const userAgent = navigator.userAgent

  if (userAgent.indexOf('Chrome') !== -1 && userAgent.indexOf('Edge') === -1) {
    return 'Chrome'
  }

  if (userAgent.indexOf('Firefox') !== -1) {
    return 'Firefox'
  }

  if (!!window.MSInputMethodContext && !!document.documentMode) {
    return 'Internet Explorer 11'
  }

  if (userAgent.indexOf('Edge') !== -1 && userAgent.indexOf('Chrome') !== -1) {
    return 'Edge'
  }

  if (userAgent.indexOf('Safari') !== -1 && userAgent.indexOf('Chrome') === -1) {
    return 'Safari'
  }
}

export default getBrowser()
